<template>
  <v-select
      v-model="input"
      :items="options"
      label="Метод ограничения даты поставок"
      item-text="name"
      item-value="id"
      :disabled="disabled"
      :error-messages="errorMessages"
      @blur="() => {this.$emit('blur')}"
      @change="onChange"
      :dense="dense"
      :outlined="outlined"
      :hide-details="errorMessages.length === 0"
  />
</template>

<script>
import * as OrderShipmentDateMethodStrategy from "@/enum/OrderShipmentDateMethodStrategyType";
export default {
  name: "SelectOrderShipmentDateMethodStrategy",
  data() {
    return {
      input: null,
      options: []
    }
  },
  props: {
    value: {
      type: Number,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: Array,
      default() {
        return []
      }
    },
    dense: {
      type: Boolean,
      default: true
    },
    outlined: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    init() {
      // init options
      this.options = Object.keys(OrderShipmentDateMethodStrategy).map(key => {
        return OrderShipmentDateMethodStrategy[key]
      })
    },
    onChange() {
      this.$emit('input', this.input)
      this.$emit('change', this.input)
    },
    onValueChanged() {
      if (typeof (this.value) === 'number')
        this.input = this.value
      else
        this.input = null
    }
  },
  created() {
    this.init()
    this.onValueChanged()
  },
  watch: {
    value() {
      this.onValueChanged()
    }
  }
}
</script>

<style scoped>

</style>